import React, { useEffect, useState } from 'react';
import './index.scss';
import clsx from 'clsx';
import { ROOT_ELEMENT_ID } from 'utils/constant';

import getMonth from 'date-fns/getMonth';
import getYear from 'date-fns/getYear';

import RadioInput from 'components/atoms/Input/RadioInput';

const dayOfTheWeekMap = [
  { key: 'Sun', value: '日' },
  { key: 'Mon', value: '月' },
  { key: 'Tue', value: '火' },
  { key: 'Wed', value: '水' },
  { key: 'Thu', value: '木' },
  { key: 'Fri', value: '金' },
  { key: 'Sat', value: '土' },
];

/**
 * 指定した年月のカレンダー情報を返す
 */
function get_month_calendar(date, minDate, selected) {
  const year = getYear(date);
  const month = getMonth(date) + 1;
  const firstDate = new Date(year, month - 1, 1); // 指定した年月の初日の情報
  const lastDay = new Date(year, firstDate.getMonth() + 1, 0).getDate(); // 指定した年月の末日
  const weekday = firstDate.getDay(); // 指定した年月の初日の曜日

  const calendarData = []; // カレンダーの情報を格納
  let weekdayCount = weekday; // 曜日のカウント用
  for (let i = 0; i < lastDay; i++) {
    const valDate = new Date(
      firstDate.getFullYear(),
      firstDate.getMonth(),
      i + 1,
    );
    calendarData[i] = {
      day: i + 1,
      weekday: weekdayCount,
      value: getStringFromDate(valDate, 'yyyyMMdd', null),
      disable: minDate ? minDate > valDate : false,
      selected:
        !!selected &&
        valDate.getFullYear() === selected.getFullYear() &&
        valDate.getMonth() === selected.getMonth() &&
        valDate.getDate() === selected.getDate(),
    };
    // 曜日のカウントが6(土曜日)まできたら0(日曜日)に戻す
    if (weekdayCount >= 6) {
      weekdayCount = 0;
    } else {
      weekdayCount++;
    }
  }

  let i = calendarData[0].weekday; // 初日の曜日を取得
  // カレンダー上の初日より前を埋める
  while (i > 0) {
    i--;
    calendarData.unshift({
      day: '　',
      weekday: i,
      value: '',
      disable: true,
      selected: false,
    });
  }
  i = calendarData[calendarData.length - 1].weekday; // 末日の曜日を取得
  // カレンダー上の末日より後を埋める
  while (i < 6) {
    i++;
    calendarData.push({
      day: '　',
      weekday: i,
      value: '',
      disable: true,
      selected: false,
    });
  }
  return calendarData;
}

/**
 * 指定した日付からXヶ月後のDateオブジェクトを取得する
 * @param {object} date   - 基準のDateオブジェクト
 * @param {number} months - 何ヶ月先の日付を取得するか
 */
function get_nextmonth_date(date, months) {
  // monthsの指定がない場合は翌月を取得
  months = months || 1;

  // 基準の年月日を取得
  const year = date.getFullYear();
  const month = date.getMonth();
  const day = date.getDate();

  // 基準の年月からDateオブジェクトを生成
  const nextDate = new Date(year, month);
  // 月の設定を変更
  nextDate.setMonth(nextDate.getMonth() + months);
  // 末日を取得
  const lastDay = new Date(
    nextDate.getFullYear(),
    nextDate.getMonth() + 1,
    0,
  ).getDate();
  // 元の日にちが該当月に無い場合はその月の末日を設定する
  if (lastDay < day) {
    nextDate.setDate(lastDay);
  } else {
    nextDate.setDate(day);
  }
  return nextDate;
}
const getStringFromDate = (date, format, valueDate) => {
  date =
    date ||
    new Date(
      `${valueDate.slice(0, 4)}/${valueDate.slice(4, 6)}/${valueDate.slice(6)}`,
    );
  format = format.replace(/yyyy/g, date.getFullYear());
  format = format.replace(/MM/g, `0${date.getMonth() + 1}`.slice(-2));
  format = format.replace(/dd/g, `0${date.getDate()}`.slice(-2));

  return format;
};

const CalendarInput = ({
  minDate,
  selected,
  dateFormat = 'yyyy年MM月dd日',
  onClickClose = true,
  left = false,
  right = false,
  radioInput,
  label,
}) => {
  const [ open, setOpen ] = useState(false);
  const [ selectValue, setSelectValue ] = useState(selected);
  const [ date, setDate ] = useState(
    !selected ? minDate || new Date() : selected,
  );
  const [ calendarData, setCalendarData ] = useState(
    get_month_calendar(date, minDate, selected),
  );
  const [ dataView, setDataView ] = useState(
    selected ? getStringFromDate(selected, dateFormat) : label,
  );
  const decreaseMonth = () => {
    const newDate = get_nextmonth_date(date, -1);
    setDate(newDate);
    setCalendarData(get_month_calendar(newDate, minDate, selectValue));
  };
  const increaseMonth = () => {
    const newDate = get_nextmonth_date(date, 1);
    setDate(newDate);
    setCalendarData(get_month_calendar(newDate, minDate, selectValue));
  };

  const dataViewChange = (e) => {
    setSelectValue(
      new Date(
        `${String(e).slice(0, 4)}/${String(e).slice(4, 6)}/${String(e).slice(
          6,
        )}`,
      ),
    );
    setDataView(getStringFromDate(null, dateFormat, String(e)));
    setCalendarData(
      get_month_calendar(
        date,
        minDate,
        new Date(
          `${String(e).slice(0, 4)}/${String(e).slice(4, 6)}/${String(e).slice(
            6,
          )}`,
        ),
      ),
    );
    setOpen(!onClickClose);
  };

  const openChange = (e) => {
    setOpen(!open);
    setDate(!selected ? minDate || new Date() : selected);
    setCalendarData(
      get_month_calendar(
        !selected ? minDate || new Date() : selected,
        minDate,
        selected,
      ),
    );
  };

  useEffect(() => {
    const root = document.getElementById(ROOT_ELEMENT_ID);
    root.addEventListener(
      'click',
      (e) => {
        if (e.target.offsetParent) {
          if (e.target.offsetParent.className === 'calender') {
            e.preventDefault();
          } else {
            setOpen(false);
          }
        }
      },
      false,
    );
  }, []);

  return (
    // ヘッダー
    <div className={clsx('calendar', { left }, { right })}>
      <RadioInput
        id={radioInput.id}
        name={radioInput.name}
        value={radioInput.value}
        onClick={openChange}
        onChange={radioInput.onChange}
        checked={radioInput.checked}
        label={dataView}
        number={radioInput.number}
      />
      <div>
        {open && (
          <div className="calender">
            <div className="calender-head">
              <div className="calender-title">
                {getYear(date)}
                年
                {' '}
                {getMonth(date) + 1}
                月
              </div>
              <button
                className="previousButton"
                type="button"
                onClick={decreaseMonth}
              >
                &lt;
              </button>
              <button
                className="increaseButton"
                type="button"
                onClick={increaseMonth}
              >
                &gt;
              </button>
            </div>
            <ul className="calender-week">
              {dayOfTheWeekMap.map((item) => {
                return <li key={item.key}>{item.value}</li>;
              })}
            </ul>
            <ul className="calender-day-warp">
              {calendarData.map((item, idx) => {
                const { disable } = item;
                const { selected } = item;
                return (
                  <li
                    key={idx}
                    className={clsx('calender-day', { disable }, { selected })}
                    value={item.value}
                    onClick={
                      () => {
                        if (!item.disable) {
                          radioInput.handleChange(item.value, radioInput.value);
                          dataViewChange(item.value);
                        }
                      }
                    }
                  >
                    {item.day}
                  </li>
                );
              })}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

export default CalendarInput;
